<template>
  <div class="flex flex-row justify-center min-h-svh bg-gray-50 w-screen">
    <NuxtLoadingIndicator  :color="loadingColor" />
    <div class="w-full mx-auto overflow-hidden">
      <div class="flex flex-col min-h-svh justify-center ">
        
        <!-- <div class="sticky top-0 z-50 w-full bg-gradient-to-b from-[#FDF5DE] to-gray-50"> -->
        <div :class="bgImageClass" ref="headerRef" class="fixed top-0 left-0 z-50 w-full bg-white shadow-sm">
          <div class="md:container px-1.5 w-full" v-if="!isNavDisabled">
            <V2NavbarComponent :textColor="bgImageClass.includes('text-white') ? 'white' : 'black'" />
            <!-- Search: only on small screens -->
            <div v-if="showSearch" class="block md:hidden w-full  mb-2 px-3">
              <div class="w-full rounded-md overflow-hidden">
                <V2SearchComponent :placeholder="categories"/>
              </div>
            </div>
          </div>
        </div>

        <!-- <header class="bg-gray-300 z-40 text-white sticky top-0">
          <div class="md:container md:self-center mx-auto">
            <slot name="header"></slot>
          </div>
        </header> -->
        <main
          class="flex-grow md:container md:self-center overflow-clip"
          :class="{ 'mb-24': !(financeApp || hasNoBottom), 'h-[calc(100svh-76px)]': financeApp }"
          :style="{ paddingBottom: footerHeight + 'px' }"
        >
          <div
            class="cursor-pointer"
            @click="scrollToTop"
            v-show="isVisible"
          >
            <div class="scrollToTop">
              <p class="">
                <UIcon
                  name="i-heroicons-arrow-up"
                  class="text-white mTop h-3 w-3"
                />
                Back to Top
              </p>
            </div>
          </div>
          <!-- <div
            v-show="isVisible"
            class="w-full flex justify-center fixed z-50"
          >
            <div
              @click="scrollToTop"
              class="cursor-pointer text-center scrollToTop"
            >
              <UIcon
                name="i-heroicons-arrow-up"
                variant="solid"
                class="text-primary mTop h-5 w-5"
              />

              <p class="text-primary mTop h-5 w-5">Back to Top</p>
            </div>
          </div> -->
          <!-- NOTE: Not sure - this parent level keep alive here is'nt working.  -->
          <div class="grid grid-cols-1 md:grid-cols-5 items-start w-full px-2 md:px-4 gap-2" v-if="isDesktop">
            <!-- Show only Edit Profile on mobile when toggled -->
            <template v-if="isMobile && showEditProfile && !showSavedAddresses">
              <div class="w-full">
                <v2EditProfileComponent />
              </div>
            </template>
            <template v-else-if="isMobile && showPrivacy">
                <v2PrivacyPolicyComponent />
            </template>
            <template v-else-if="isMobile && showTerms">
                <v2TermsAndCondition />
            </template>
            <template v-else-if="isMobile && showContacts">
                <V2ContactUsComponent />
            </template>
            <template v-else-if="isMobile && showFaQs">
                <v2FaQComponent />
            </template>
            <template v-else>
              <!-- Left Column -->
              <div class="md:col-span-2 flex">
                <!-- Left Sidebar -->
                <aside
                  class="w-full sm:w-[400px] md:w-[440px] lg:w-[600px] bg-white rounded-[12px] shadow-sm
                        p-4 sm:p-6 md:p-4 flex flex-col gap-6 overflow-y-auto sm:mt-12 md:mt-10">
                  <!-- Profile Section -->
                  <div
                    class="flex items-center w-full p-4 gap-6 rounded-[12px] border-b border-gray-300">
                    <!-- Avatar -->
                    <div
                      class="w-[72px] h-[72px] sm:w-[88px] sm:h-[88px] rounded-full bg-[#FFEDD5] flex items-center justify-center">
                      <img src="/v2/images/profile.png" alt="profile" title="User profile" class="w-10 sm:w-12" />
                    </div>
                    <!-- Text block -->
                    <div class="flex flex-col items-start ml-4 sm:ml-6">
                      <div v-if="auth.user.first_name">
                        <h2 class="font-rubik font-bold text-lg sm:text-xl md:text-2xl text-[#03140F]">
                          {{ auth.user.first_name }}
                        </h2>
                        <p class="font-rubik font-normal text-sm sm:text-base text-[#626363]">
                          <span class="flex items-center gap-2" v-if="auth.user.email">
                            <UIcon name="i-heroicons-envelope" class="h-4 w-4 text-gray-400" />
                            <span>{{ auth.user.email }}</span>
                          </span>
                          <span class="flex items-center gap-2" v-if="auth.user.phone">
                            <UIcon name="i-heroicons-phone" class="h-4 w-4 text-gray-400" />
                            <span>{{ auth.user.phone }}</span>
                          </span>
                        </p>
                      </div>
                      <div v-else>
                        <h2 class="font-rubik font-bold text-lg sm:text-xl md:text-2xl text-[#03140F]">
                          Welcome User!
                        </h2>
                      </div>
                        <a
                          v-if="!checkComplete"
                          href="#"
                          class="text-xs sm:text-sm font-medium underline mt-1"
                          style="color:#0C5542;"
                          @click.prevent="toggleEditProfile">
                          Create your account
                        </a>
                        <a
                          v-else
                          href="#"
                          class="text-xs sm:text-sm font-medium underline mt-1"
                          style="color:#0C5542; font-weight: extra-bold;"
                          @click.prevent="toggleEditProfile">
                          Edit profile
                        </a>
                    </div>
                  </div>
                  <!-- My Orders & Addresses -->
                  <div class="flex flex-wrap sm:flex-nowrap gap-4 w-full">
                    <button
                      @click="navigate('/account/orders')"
                      class="flex items-center justify-start flex-1 gap-3 px-4 py-2 h-12 sm:h-14
                      bg-white border border-[#E9E9E9] rounded-xl hover:bg-gray-50 transition">
                      <UIcon name="i-heroicons-shopping-cart" class="h-5 w-5 text-[#111111]" />
                      <span class="font-rubik font-semibold text-sm sm:text-base md:text-lg text-[#111111]">
                        My orders
                      </span>
                    </button>
                    <button
                    @click="openSavedAddresses"
                      class="flex items-center justify-start flex-1 gap-3 px-4 py-2 h-12 sm:h-14
                            bg-white border border-[#E9E9E9] rounded-xl hover:bg-gray-50 transition">
                      <UIcon name="i-heroicons-map-pin" class="h-5 w-5 text-[#111111]" />
                      <span class="font-rubik font-semibold text-sm sm:text-base md:text-lg text-[#111111]">
                        My addresses
                      </span>
                    </button>
                  </div>
                  <!-- Help & Support -->
                  <div
                    class="w-full bg-white rounded-[12px] border border-[#E9E9E9] p-4 flex flex-col justify-between">
                    <!-- Top Section -->
                    <div class="flex flex-col gap-4">
                      <h3
                        class="flex items-center gap-2 font-rubik font-semibold text-base sm:text-lg text-[#111111]">
                        <UIcon name="i-heroicons-calendar" class="h-5 w-5 text-[#111111]" />
                        Help and Support
                      </h3>
                      <ul class="flex flex-col gap-4">
                        <li class="flex items-center gap-2 text-sm sm:text-base text-[#111111] cursor-pointer"
                          @click="openFaQs">
                        <UIcon name="i-heroicons-chat-bubble-oval-left-ellipsis" class="h-5 w-5" />
                        FAQs
                      </li>
                        <div class="border-t border-[#E9E9E9]"></div>
                        <li class="flex items-center gap-2 text-sm sm:text-base text-[#111111]">
                          <UIcon name="i-heroicons-inbox-stack" class="h-5 w-5" />
                          Raise a request
                        </li>
                        <div class="border-t border-[#E9E9E9]"></div>
                        <li class="flex items-center gap-2 text-sm sm:text-base text-[#111111] cursor-pointer"
                          @click="openContact">
                          <UIcon name="i-heroicons-phone" class="h-5 w-5" />
                          Contact us
                        </li>
                      </ul>
                    </div>
                    <!-- Bottom Section -->
                    <div class="border-t border-[#E9E9E9] mt-4"></div>
                    <div
                      class="flex items-center gap-2 text-xs sm:text-sm md:text-base font-medium mt-4">
                      <UIcon name="i-heroicons-chat-bubble-bottom-center" class="h-5 w-5 text-gray-400" />
                      Chat with us
                      <span
                        class="inline-flex items-center justify-center px-2 h-5 text-[10px] sm:text-xs font-semibold text-[#1D4ED8] rounded bg-[#DEEAFF]">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <!-- About Us -->
                  <div
                    class="w-full bg-white rounded-[12px] border border-[#E9E9E9] p-4 flex flex-col gap-4">
                    <h3
                      class="flex items-center gap-2 font-rubik font-semibold text-base sm:text-lg text-[#111111]">
                      <UIcon name="i-heroicons-chat-bubble-left" class="h-5 w-5" />
                      About us
                    </h3>
                    <ul class="flex flex-col gap-4">
                      <li class="flex items-center gap-2 text-sm sm:text-base text-[#111111]">
                        <UIcon name="i-heroicons-exclamation-circle" class="h-5 w-5" />
                        About Hamara Mall
                      </li>
                      <div class="border-t border-[#E9E9E9]"></div>
                      <li
                        class="flex items-center gap-2 text-sm sm:text-base text-[#111111] cursor-pointer"
                        @click="openTerms"
                      >
                        <UIcon name="i-heroicons-chat-bubble-oval-left-ellipsis" class="h-5 w-5" />
                        Terms and conditions
                      </li>
                      <div class="border-t border-[#E9E9E9]"></div>
                      <li
                        class="flex items-center gap-2 text-sm sm:text-base text-[#111111] cursor-pointer"
                        @click="openPrivacy"
                      >
                        <UIcon name="i-heroicons-shield-check" class="h-5 w-5" />
                        Privacy policy
                      </li>
                    </ul>
                  </div>
                  <!-- Settings -->
                  <div
                    class="w-full bg-white rounded-[12px] border border-[#E9E9E9] p-4 flex items-center gap-2 cursor-pointer">
                    <UIcon name="i-heroicons-cog-6-tooth" class="h-5 w-5" />
                    <span class="font-rubik font-bold text-base sm:text-lg text-[#111111]">
                      Settings
                    </span>
                  </div>
                  <!-- Dark Mode -->
                  <!-- <div
                    class="w-full bg-white rounded-[12px] border border-[#E9E9E9] p-4 flex items-center justify-between"
                  > -->
                    <!-- <div class="flex items-center gap-2">
                      <UIcon name="i-heroicons-moon" class="h-5 w-5" />
                      <span class="font-rubik font-bold text-base sm:text-lg text-[#111111]">
                        Dark mode
                      </span>
                    </div> -->
                    <!-- <label class="inline-flex items-center cursor-pointer">
                      <input type="checkbox" value="" class="sr-only peer" checked />
                      <div
                        class="relative w-11 h-6 bg-gray-200 rounded-full peer-checked:bg-green-500"
                      >
                        <div
                          class="absolute top-[2px] left-[2px] h-5 w-5 bg-white rounded-full transition-transform peer-checked:translate-x-full"
                        ></div>
                      </div>
                    </label> -->
                  <!-- </div> -->
        
                  <!-- Share App -->
                  <!-- <div
                    class="w-full bg-white rounded-[12px] border border-[#E9E9E9] p-4 flex items-center gap-2 cursor-pointer"
                  >
                    <UIcon name="i-heroicons-share" class="h-5 w-5" />
                    <span class="font-rubik font-semibold text-base sm:text-lg text-[#111111]">
                      Share the App
                    </span>
                  </div> -->
                </aside>
              </div>
              <!--Right Column-->
              <div class="md:col-span-3 w-full sm:mt-12 md:mt-6">
                    <div v-if="!isMobile && !showSavedAddresses && showEditProfile">
                        <v2EditProfileComponent />
                    </div>
                    <div v-else-if="showSavedAddresses">
                        <V2AddressPicker v-if="hasSavedAddresses" :addresses="savedAddresses" @close="showSavedAddresses = false" />
                        <!-- <AddressesComponent v-else @close="showSavedAddresses = false" /> -->
                    </div>
                    <div v-else-if="showFaQs">
                        <v2FaQComponent @close="showFaQs = false" />
                    </div>
                    <div v-else-if="showTerms">
                        <v2TermsAndCondition @close="showTerms = false" />
                    </div>
                    <div v-else-if="showPrivacy">
                        <v2PrivacyPolicyComponent @close="showPrivacy = false" />
                    </div>
                    <div v-else-if="showContacts">
                        <V2ContactUsComponent @close="showContacts = false" />
                    </div>
                    <div v-else>
                        <slot name="main" />
                    </div>
              </div>
            </template>
          </div>
          <div v-if="isMobile">
            <slot name="main" :class="{ 'mb-8': !(financeApp || hasNoBottom) }" />
          </div>

          <V3PageLoaderComponent
            v-if="isLoading && showLoader"
            class="dark:text-black fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white/80 z-50"
          />
          <div class="p-5 md:p-8">
            <V2Footer v-if="partnerCode.toLowerCase() !== 'oneindiamall'"/>
          </div> 
        </main>
        <footer
          ref="footerRef"
          v-if="!route.meta.hideFooter"
          class="flex flex-col fixed bottom-0 w-full z-10 sm:shadow-2xl sm:p-4 sm:bg-gray-100 sm:border-t"
        >
          <slot name="footer"></slot>
          <!-- start: footer navigation for mobile view -->
          <div
            v-if="showFooterNavigation"
            class="sm:hidden w-full flex justify-between bg-white shadow-2xl shadow-black px-2 overflow-scroll"
          >
            <div
              v-for="item in navIcons.footerNavIcons"
              :key="item.name"
              @click="handleFooterClick(item.name)"
              class="min-w-14 w-full relative pt-2 px-2 py-2 cursor-pointer"
            >
              <div class="flex flex-col items-center justify-between">
                <div
                  v-if="isActiveFooterItem(item)"
                  class="absolute top-0 w-full h-[5px] bg-orange-500 rounded-b-xl"
                ></div>
                <div class="flex flex-col items-center justify-center pt-1">
                  <div>
                    <span
                      v-if="item.badge && item.badge > 0"
                      class="absolute top-2 right-4 bg-primary-600 text-white text-xs leading-3 rounded-full h-4 w-4 flex items-center justify-center"
                    >
                      {{ item.badge }}
                    </span>
                    <img
                      :src="
                        isActiveFooterItem(item) ? item.activeIcon : item.icon
                      "
                      :alt="item.label"
                      :title="item.label"
                      class="w-6 h-6"
                    />
                  </div>
                  <p
                    class="px-0.5 text-center text-xs leading-5 text-navyPrime w-16 truncate"
                    :class="{ 'text-primary-600': isActiveFooterItem(item) }"
                  >
                    {{ item.label }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- end: footer navigation for mobile view -->
        </footer>

        <UNotifications />
        <USlideovers />
        <UModals />
      <LoginBanner
  :message="loginBannerMessage"
  :footer-height="footerHeight"
/>

      </div>
    </div>
  </div>
</template>

 <script setup>
  import { ref, onBeforeMount,onMounted,onUnmounted } from 'vue';
  import LoginBanner from '@/components/v4/LoginBanner.vue'
  import { useLoginBanner } from '@/composables/useLoginBanner'
  const { isMobile, isDesktop } = useDevice();
  const slideover = useSlideover();
  const modal = useModal();
  const location = useLocation();
  const isLocationAvailable = computed(() => location.isGPSEnabled);
  const { isPopupOpen, openPopup, closePopup } = popupBackHandler()  
  const isFetchingLocation = ref(false);
  const loadingMessage = ref('');
  const { gtag } = useGtag();
  const route = useRoute();
  const { isLoading } = useLoadingIndicator();
  const showLoader = computed(() => route.meta.showLoader ?? true);
  const navIcons = useNavIcons();
  const lastScrollPosition = ref(0);
  const auth = useAuth();
    const isAuthenticated = auth && auth.access_token;
    const userData = isAuthenticated ? {
      user_name: auth.user.first_name,
      user_phone: auth.user.phone,
      user_email: auth.user.email,
    } : {
      user_name: null,
      user_phone: null,
      user_email: null
    };
  import { V3PopupComponent, V3ModalComponent } from "#components";
  const bgImageClass = computed(() => {
    if (route.path.toLowerCase() === "/" || route.path.toLowerCase() === "/homepagev2") {
      return "bg-contain bg-center md:bg-[url('/v2/banner/FestiveHeaderDesktop.jpeg')] bg-[url('/v2/banner/FestiveHeaderMobile.jpeg')]";
    } else if (route.path.toLowerCase() === "/deals") {
      return "bg-[#7F1439] text-white";
    } else {
      return "bg-gradient-to-b from-[#FDF5DE] to-gray-50 text-black";
    }
  });
  const blacklist = ["location-finder",'loans'];
  const isNavDisabled = blacklist.includes(route.name.toLowerCase());
  const { data: categoryResult } = await useAPIHandler("get", "/categories");
  const categories = categoryResult.categories
    .filter((k) => k.displayName !== "Appliances")
    .map((k) => k.displayName)
    .sort((a, b) => a.localeCompare(b));
  const financeApp = ['finance-app-dashboard'].includes(route.name.toLowerCase());
  const hasNoBottom = computed(() =>
    ["index", "collections-rebelfoods"].includes(route.name.toLowerCase())
  )
  const footerRef = ref(null);
  const footerHeight = ref(0);
  const updateFooterHeight = () => {
    if (footerRef.value) {
      footerHeight.value = footerRef.value.offsetHeight;
    }
  };
  const isVisible = ref(false);
  const scrollToTop = () => {
    gtag("event", "cta_event", {
      action: "click",
      cta_name: "back to top",
      lastScrollPosition: lastScrollPosition,
      ...userData,
    });
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const footerNavPreHandlers = [
    {
      routeName: "__all__",
      preHandlers: [
        () => {
          return route.query && route.query?.from !== "checkout";
        },
        () => {
          return route.path !== "/checkout";
        },
        // for routes like ocalhost:3001/order-summary
        () => {
          return route.path !== "/order-summary";
        },
        () => {
          return route.path !== "/select-location";
        },
      ],
    }, // Default handler to show footer navigation
  ];
  const showFooterNavigation = computed(() => {
    // check for default pre-handlers first
    const defaultFooterRoutePreHandler =
      footerNavPreHandlers.find((handler) => handler.routeName === "__all__") ||
      {};
    const defaultPreHandlers = defaultFooterRoutePreHandler.preHandlers || [];
    const shouldShowDefault = defaultPreHandlers.every((handler) => handler());
    if (!shouldShowDefault) {
      return false;
    }
    // Check if the current route has specific pre-handlers
    const routeName = route.name;
    const footerRoutePreHandler =
      footerNavPreHandlers.find((handler) => handler.routeName === routeName) ||
      {};
    const preHandlers = footerRoutePreHandler.preHandlers || [];
    const shouldShow = preHandlers.every((handler) => handler() !== false);
    return shouldShow;
  });
  const { loginBannerMessage } = useLoginBanner()
  const handleFooterClick = async (routeName) => {
    // gtag('event', 'cta_event', {
    //   action: 'click',
    //   cta_name: `footer ${path}`,
    //   ...userData,
    // });
    let routes = [
      "/account/orders",
    // "/cart",
      "/account/profile",
      "/select-location",
      "/account/tickets",
      "/account/profile",
      "/support/raise_a_request",
    ];
    if (isAuthenticated == null && routes.includes(routeName)) {
      if (isMobile) {
        slideover.open(V3PopupComponent, {
          component: "login",
          closable: true,
          onSuccess: () => {
            useSSOAuth(routeName);
          },
          onClose: slideover.close,
        });
      } else {
        modal.open(V3ModalComponent, {
          component: "login",
          closable: true,
          onSuccess: () => {
            useSSOAuth(routeName);
          },
          onClose: modal.close,
        });
      }
      return;
    } else {
      await navigateTo({ path: routeName });
    }
  };
  const isActiveFooterItem = (item) => {
    return route.path === item.name;
  };
  const showSearch = computed(() => {
    // check if the current route matches any hide pattern
    return !hideSearchPatterns.some(pattern => route.path.startsWith(pattern));
  });
  const hideSearchPatterns = [
    '/categories/search-v2',
    '/shop',
    '/cart',
    '/coupons',
    '/collections',
    '/search',
    '/v2/search',
    '/filter/v2'
  ];
  const paths = [
    // "/providers",
    "/categories",
    "/categories/v2",
    "/deals",
    "/",
    "/collections/mahaKumbh",
    "/collections",
    "/categories/search",
    "/categories/search-v2",
  ];

  const showContact = () => {
    
    gtag('event', 'cta_event', {
      action: 'click',
      cta_name: 'contact us',
      ...userData,
    });
 
    openPopup();
    const options = {
      component: 'contactUS',
      onSuccess:()=>{
        slideover.close();
      },
      onClose: () => {
        // Close the popup when the "X" button is clicked
        if (isMobile) {
          slideover.close();
        } else {
          modal.close();
        }
        history.replaceState(null, '', window.location.href);
      },
    };
    if (isMobile) {
      slideover.open(V3PopupComponent, options);
    } else {
      modal.open(V3ModalComponent, options);
    }
    
  };
  watchEffect(() => {
    if (isPopupOpen.value && !modal.isOpen.value && !slideover.isOpen.value) {
      closePopup(); // ensures we trigger history.back() even if closed by outside click
    }
  });
  watch(isPopupOpen, (newVal) => {
    if (!newVal) {
      if (slideover.isOpen.value) slideover.close();
      if (modal.isOpen.value) modal.close();
    }
  });
  
  const showEditProfile = ref(false)
  const showFaQs = ref(false) // <-- NEW
  const showTerms = ref(false)
const showPrivacy = ref(false)
const showContacts = ref(false)
const runtimeConfig = useRuntimeConfig();
const partnerCode = runtimeConfig.public.partnerCode;
import V2AddressPicker from '~/components/v2/address-picker/index.vue'
//import AddressesComponent from '~/components/v2/AddressesComponent.vue'
const showSavedAddresses = ref(false)
const savedAddresses = ref([])
const hasSavedAddresses = computed(() => savedAddresses.value && savedAddresses.value.length > 0)
 
  const openSavedAddresses = async () => {
    showEditProfile.value = false
    showSavedAddresses.value = true
    // Fetch saved addresses
    try {
      const response = await useAPIHandler('get', '/account/addresses', { auth: true })
      savedAddresses.value = response.data || []
    } catch (e) {
      savedAddresses.value = []
    }
  }

  const menu = [{
    title: 'My profile',
    icon: 'icons/order.png',
    href: '/account/profile'
  }, {
    title: 'My Saved Addresses',
    icon: 'icons/saved_address.png',
    href: '/select-location'
  }, {
    title: 'My Orders',
    icon: 'icons/order.png',  
    href: '/account/orders'
  },
  // {
  //   title: 'My Gift Cards',
  //   icon: 'icons/order.png',  
  //   href: '/collections/gift-cards/giftcardslistnew'
  // },
  {
    title: 'My Tickets',
    icon:'icons/raise_a_request.png',  
    href: '/account/tickets'
  },
   {
    title: 'Help & Support',
    icon: 'icons/h&s.png',
    href: '/support',
    submenu: [
        {
          title: 'Frequently Asked Questions (FAQs)',
          icon:'icons/faq.png',
          href: '/support/faq'
        },
        {
          title: 'Raise a Request',
          icon:'icons/raise_a_request.png',
          href: '/support/raise_a_request'
        },
        {
          title: 'Contact us',
          icon:'icons/contact.png',
          action: showContact
        }
      ]
  },
  {
    title: 'About Hamara Mall',
    icon: 'icons/aboutus.png',
    href: '/about',
    submenu: [
        {
          title: 'About Us',
          icon:'icons/mall4allabout.png',
          href: '/about/aboutUs'
        },
        {
          title: 'Terms and Conditions',
          icon:'icons/t&c.png',
          href: '/about/terms'
        },
        {
          title: 'Privacy Policy',
          icon:'icons/privacy.png',
          href: '/about/privacy-policy'
        }
      ]
  }]
  const openSubmenu = ref(null);
  
  const toggleSubmenu = (index) => {
    openSubmenu.value = openSubmenu.value === index ? null : index;
  };
 
  const requiredFields = ["email", "first_name", "last_name", "dob", "gender"];
  const profileCompletion = computed(() => {
    const filledFields = requiredFields.filter(field => auth.user[field]);
    return Math.round((filledFields.length / requiredFields.length) * 100);
  });
 
  const loadingColor = computed(() => {
  if (partnerCode?.toLowerCase() === 'oneindiamall') {
    return `linear-gradient(180deg, #ea71b5, #CA5096)`;
  }  
  return undefined; 
  });
  
 
  const authToken = computed(() => auth.access_token);  
  
  const checkComplete = computed(() =>{
    if(!auth.user.email || !auth.user.last_name || !auth.user.dob || !auth.user.gender  ){
        return false
    }else return true
  })
 
  const navigate = (href) => {
    const lastValue = href.split('/').pop();
    gtag('event', 'cta_event', {
      action: 'click',
      cta_name: 'quick menu',
      actionName: lastValue,
      ...userData,
    });
    return navigateTo({ path: href });
  }
  
  const emit = defineEmits(['close']);
  const logout = async () => {
    gtag('event', 'cta_event', {
      action: 'click',
      cta_name: 'logout',
      ...userData,
    });
    localStorage.removeItem("appliedCoupon");
    localStorage.removeItem('addressSelected');
    auth.$reset();
    useReward().$reset();
    emit('close');
    await navigateTo({ path: '/' });
  }
  
  const version = ref(null);
  const loading = ref(true);
  onMounted(() => {
    localStorage.removeItem('current_category_tab');
    // if (!isLocationAvailable.value) {
    //   loadingMessage.value = 'Fetching current location please wait...';
    //   isFetchingLocation.value = true;
    //   const { getCurrentLocation, emitter } = useLocationFinder();
    //   getCurrentLocation();
    //   emitter.on('success', async (coords) => {
    //       await location.setCoords(coords.latitude, coords.longitude);
    //       isFetchingLocation.value = false;
    //       loadingMessage.value = "";
    //       window.location.reload(); // reload to re-trigger any logic dependent on location
    //     });
    //     emitter.on('error', () => {
    //       handleLocationError('Unable to fetch location. Please select manually.')
    //     })
    //   return;
    // }
    if (!auth.access_token) {
      forceLoginUntilSuccess()
      return
    }
    navIcons.getFooterNavIcons();

    // This is vital for dynamic content in the footer slot
    updateFooterHeight();
    window.addEventListener("resize", updateFooterHeight);

    const handleScroll = () => {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;

      if (
        currentScrollPosition > 0 &&
        route.path.startsWith("/providers") &&
        !isMobile
      ) {
        isVisible.value = true;
      } else {
        if (currentScrollPosition > 0 && paths.includes(route.path)) {
          isVisible.value = true;
        } else {
          isVisible.value = false;
        }
      }

      lastScrollPosition.value = currentScrollPosition;
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
    });
  });

const forceLoginUntilSuccess = () => {
    const options = {
      component: 'login',
      closable: false,
      onSuccess: () => {
        if (isMobile) slideover.close()
        else modal.close()
        useSSOAuth('/account/profile')
      },
      onClose: () => {
        // If still unauthenticated after close (including background click), reopen
        if (!auth.access_token) {
          nextTick(() => {
            forceLoginUntilSuccess()
          })
        }
      }
    }
    if (isMobile) {
      slideover.open(V3PopupComponent, options)
    } else {
      modal.open(V3ModalComponent, options)
    }
  }
  onBeforeMount(async () => {
    try {
      const response = await useAPIHandler('get', '/account/getVersion');
      if (response.data) {
        version.value = response.data;
      } else {
        version.value = null;
      }
    } catch (error) {
      console.error("Error fetching version data:", error);
      version.value = null;
    }finally {
      loading.value = false;
    }
  });
  const handleLocationError = (
      message = 'Something went wrong while fetching location. Please select manually.'
    ) => {
      loadingMessage.value = message
      isFetchingLocation.value = false
      const routeUrl = useRoute();
      const popupOptions = {
        component: 'location',
        onSuccess: () => window.location.reload(),
        onClose: () => (isMobile ? slideover.close() : modal.close()),
      }
      if (!location.city?.name && !isAuthenticated) {
        isMobile
            ? slideover.open(V3PopupComponent, popupOptions)
            : modal.open(V3ModalComponent, popupOptions)
      }
      else if(!location.city?.name && isAuthenticated && routeUrl.path !== '/'){
        navigateTo({ path: '/select-location', query: { from: 'home' } })
      }
}  
  gtag('event', 'cta_event', {
      action: 'click',
      cta_name: 'header profile icon',
      ...userData,
    });
  definePageMeta({
    // keepalive: true,
  })
  // Track mobile view and modal toggle
// const checkMobile = () => {
//   isMobile.value = window.innerWidth < 768 // Tailwind md breakpoint
// }
 
// Method to handle showing FAQs
const openFaQs = () => {
  showEditProfile.value = false
  showSavedAddresses.value = false
  showFaQs.value = true
  showTerms.value = false
  showPrivacy.value = false
  showContacts.value = false
}
const toggleEditProfile = () => {
  showEditProfile.value = true
  showSavedAddresses.value = false
  showFaQs.value = false
  showTerms.value = false
  showPrivacy.value = false
  showContacts.value = false
}
const openTerms = () => {
  showEditProfile.value = false
  showSavedAddresses.value = false
  showFaQs.value = false
  showPrivacy.value = false
  showContacts.value = false
  showTerms.value = true
}
const openPrivacy = () => {
  showEditProfile.value = false
  showSavedAddresses.value = false
  showFaQs.value = false
  showTerms.value = false
  showContacts.value = false
 
  showPrivacy.value = true
}
 
const openContact = () => {
  showEditProfile.value = false
  showSavedAddresses.value = false
  showFaQs.value = false
  showTerms.value = false
  showPrivacy.value = false
  showContacts.value = true
  
}

onUpdated(() => {
  // This is vital for dynamic content in the footer slot
  updateFooterHeight();
});

onUnmounted(() => {
  window.removeEventListener("resize", updateFooterHeight);
})
</script>

<style>
.scrollToTop {
  border: solid;
  border-color: #002953;
  background-color: #002953;
  color: white;
  border-radius: 50px;
  width: 100px;
  z-index: 50;
  bottom: 80px;
  right: 20px;
  position: fixed;
  font-size: 12px;
  padding: 5px;
}

.mTop {
  margin-top: 2px;
}
</style>
